import styles from "./stars.module.css";

export const Stars = ({
  number,
  color,
  fontSize




}: {number: number;color?: string;fontSize?: string;}) => {
  const starsArray = Array.from(Array(Math.round(number)).keys());
  const emptyStarsArray = Array.from(Array(5 - Math.round(number)).keys());
  return (
    <div className={styles.stars}>
      {starsArray.map((s) =>
      <div
        className={styles.star}
        color={color}
        key={s}
        role={"star"}
        style={{
          fontSize: fontSize || "28px"
        }}>

          <span className='icon-star-fill'></span>
        </div>
      )}
      {emptyStarsArray.map((s) =>
      <div
        className={styles.star}
        color={color}
        key={s}
        role={"star"}
        style={{
          fontSize: fontSize || "28px"
        }}>

          <span className='icon-star'></span>
        </div>
      )}
    </div>);

};